import { createSvgIcon } from '@mui/material'

export const RestowIcon = createSvgIcon(
  <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect y='0.5' width='24' height='24' rx='4' fill='#637381' />
    <path
      d='M7.184 18.5V6.932H12.248C13.2133 6.932 13.9947 7.08933 14.592 7.404C15.1893 7.71333 15.6267 8.14 15.904 8.684C16.1813 9.22267 16.32 9.836 16.32 10.524C16.32 11.1267 16.2347 11.6387 16.064 12.06C15.8933 12.476 15.6613 12.828 15.368 13.116C15.08 13.3987 14.7547 13.6387 14.392 13.836L16.48 18.5H13.68L11.896 14.276H9.912V18.5H7.184ZM9.912 12.22H11.872C12.384 12.22 12.7947 12.0573 13.104 11.732C13.4187 11.4067 13.576 11.02 13.576 10.572C13.576 10.1027 13.416 9.71867 13.096 9.42C12.776 9.12133 12.3947 8.972 11.952 8.972H9.912V12.22Z'
      fill='white'
    />
  </svg>,
  'RestowIcon',
)
